
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.2","d":"M6 21V4.878m13.222 9.53V4.944s-.826.687-3.305.687C13.437 5.631 11.785 4 9.306 4 6.826 4 6 4.88 6 4.88m0 9.509s.826-.687 3.306-.687c2.479 0 4.132 1.631 6.61 1.631 2.48 0 3.306-.922 3.306-.922"}})])
          )
        }
      }
    